import { jwtDecode } from "jwt-decode"; // Corrected import statement

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token); // Use the imported function directly
    // Check if token is expired (exp is in seconds, Date.now() is in milliseconds)
    return decoded.exp * 1000 > Date.now();
  } catch (error) { // Catch potential errors during decoding
    console.error("Error decoding token:", error);
    return false; // Treat decoding errors as unauthenticated
  }
};

export const logout = () => {
  localStorage.removeItem("token");
  // Consider using navigate hook if this is inside a component,
  // otherwise window.location is okay but causes a full page reload.
  window.location.href = "/login";
};